import { type ModalProps as ParallaxModalProps } from '@adc/parallax-component-library';

export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export type ModalState = {
  isOpen: boolean;
  modalProps: ModalProps | null;
};

export type ModalProps = {
  primaryAction?: ParallaxModalProps['primaryAction'];
  header?: string;
  details?: string | React.ReactElement;
  onClose?: () => void;
  testID: string;
} & Pick<ParallaxModalProps, 'secondaryAction' | 'buttonLayout'>;

type ModalShowAction = {
  type: typeof SHOW_MODAL;
  modalProps: ModalProps;
};

type ModalCloseAction = {
  type: typeof CLOSE_MODAL;
};

export type ModalActions = ModalShowAction | ModalCloseAction;
